// extracted by mini-css-extract-plugin
module.exports = {"Single":"single-module--Single--qX0C3"};